'use strict';

var findabilityDecoder = {};

/**
 * @param {string} text string
 * Hyphenates all spaces and +
 */
findabilityDecoder.hyphenateSpaces = function (text) {
  return text.toLowerCase().replace(/((%20)|\s|\+)+/g, '-');
};

/**
 * @param {string} text string
 * Strips everything but A-Z, a-z, 0-9, hyphens but removes hyphens at start and end
 */
findabilityDecoder.stripPunctuation = function (text) {
  return text.replace(/[^a-zA-Z0-9-]/g, '').replace(/^-*|-*$/g, '');
};

/**
 * @param {string} text Encoded string
 */
findabilityDecoder.encode = function (text) {
  return text.replace(/-/g, '%252D').replace(/%20/g, '-').replace(/%2B/g, '+');
};

/**
 * @param {string} text Encoded string
 */
findabilityDecoder.decode = function (text) {
  return text.replace(/-/g, '%20').replace(/%252D/g, '-');
};

/**
 * @param {string} text Encoded string
 */
findabilityDecoder.getSanitised = function (text) {
  return decodeURIComponent(findabilityDecoder.decode(text));
};

module.exports = findabilityDecoder;
//# sourceMappingURL=FindabilityDecoder.js.map